/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  
  function initMap() {
    // Create a map object and specify the DOM element for display.
    var myLatLng = {lat: 41.544703, lng: -83.6462277};
    var map = new google.maps.Map(document.getElementById('contactMap'), {
      center: myLatLng,
      scrollwheel: false,
      draggable: false,
      disableDoubleClickZoom: true,
      disableDefaultUI: true,
      zoom: 12
    });
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      clickable: false,
    });
  }
  
  function stickyFooter() {
    var stickySubtract = $(window).height() - ($(".topNav").innerHeight() + $(".footerNav").innerHeight());
    $(".mainContent, .mainContent .contentHldr").css({'min-height': stickySubtract + 'px'});
  }
  
  // Resize Events
  $( window ).resize(function() {
    //stickyFooter();
  });
  
  $(function() {
    //stickyFooter();
    // Sets interval...what is transition slide speed?
    $('#myCarousel').carousel({
      interval: 7000
    });
    initMap();
  });

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
